import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQuery } from "react-responsive";
import { useSwiperSlide } from "swiper/react";
import { VideoPlayer } from "@jti/ui/components/VideoPlayer";
import { extractVideoMetadata } from "../../utils/extractVideoMetadata/extractVideoMetadata";
export const ProductGalleryVideo = ({ item }) => {
    const isMobile = useMediaQuery({ maxWidth: 479 });
    const swiperSlide = useSwiperSlide();
    const { previewPath, path, videoContentDto, autoPlayEnabled } = item;
    const posterUrl = videoContentDto ? path : previewPath;
    const videoUrl = videoContentDto?.videoUrl ? videoContentDto.videoUrl : path;
    const videoMetadata = extractVideoMetadata(videoContentDto);
    const autoplayOnDesktop = (autoPlayEnabled || videoMetadata.autoPlay) && !isMobile;
    if (!videoUrl) {
        return null;
    }
    return (_jsx(VideoPlayer, { desktopSrc: videoUrl, poster: posterUrl, autoPlay: autoplayOnDesktop && swiperSlide?.isActive, className: "aem-carousel__galleryMedia", showControls: true, loop: autoplayOnDesktop, showFullscreen: true, squareContainer: true, keepOriginalAspectRatio: true, shouldStopVideo: swiperSlide && !swiperSlide.isActive }));
};
//# sourceMappingURL=ProductGalleryVideo.js.map